import { Navigate, createFileRoute, useRouterState } from "@tanstack/react-router";

import { calendarDayParam, enumParam, stringParam } from "../../../lib/url-state";
import {
  RESULT_PARAMS,
  ignoredFilters,
  type EpisodesSearch,
} from "../../../workspaces/production/episodes-search";
import { EpisodesPage } from "../../../workspaces/production/pages/EpisodesPage";
import { useSeat } from "../../../workspaces/production/seat";
import { canManageFloor } from "../../../workspaces/production/vocabulary";

/* Every recorded episode on the floor, narrowed by the address. The door serves the floor's
 * episodes to floor managers only, so a collector lands on the pods, as at the overview. */
export const Route = createFileRoute("/_console/production/episodes")({
  validateSearch: (search: Record<string, unknown>): EpisodesSearch => ({
    from: calendarDayParam(search.from),
    to: calendarDayParam(search.to),
    pod: stringParam(search.pod),
    operator: stringParam(search.operator),
    task: stringParam(search.task),
    collection: stringParam(search.collection),
    result: enumParam(search.result, RESULT_PARAMS),
  }),
  component: Episodes,
});

function Episodes() {
  if (!canManageFloor(useSeat())) return <Navigate to="/production/pods" replace />;
  return <FloorEpisodes />;
}

function FloorEpisodes() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const raw = useRouterState({ select: (state) => state.location.searchStr });
  return (
    <EpisodesPage
      search={search}
      ignored={ignoredFilters(new URLSearchParams(raw), search)}
      onSearchChange={(next) => void navigate({ search: next, replace: true })}
    />
  );
}
